import React from 'react';
import styled from 'styled-components';
import { ButtonText } from 'components/Button';
import { Text } from 'components/Typography';
import { lineHeight, theme, toRem } from 'design';

interface IDetailsAccordionProps {
  title: string;
  buttonText?: string;
  children: React.ReactNode;
}

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  padding: ${toRem(theme.space.lg)};
  background: ${theme.color.white};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(8)};
  gap: ${toRem(theme.space.sm)};
`;

const StyledButtonText = styled(ButtonText)`
  width: fit-content;
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  font-weight: ${theme.font.weight.medium};
  color: ${theme.color.primary[600]};
  text-decoration: none;
`;

const TextButtonAccordion = ({ title, buttonText = '', children }: IDetailsAccordionProps) => {
  const [contentVisible, setContentVisible] = React.useState(false);

  return (
    <Layout data-cy="text-button-accordion">
      <Text size="small" fontWeight="semibold">
        {title}
      </Text>
      <StyledButtonText label={`${contentVisible ? 'Hide' : 'View'} ${buttonText}`} onClick={() => setContentVisible(!contentVisible)} />
      {contentVisible && children}
    </Layout>
  );
};

export default TextButtonAccordion;
